import { useEffect } from 'react';
import * as FullStory from '../../utils/fullstory/fullstory';
import { useConsentGroups } from '../../hooks/useConsentGroups';
import { useSelector } from 'react-redux';
import { ENABLE_FS_USER_PROPERTIES, ENABLE_FULLSTORY } from '../../constants';

const FullStoryManager = () => {
  const FULLSTORY_ORG_ID = 'o-1JPS6J-na1';
  const {
    userId,
    linkedOrgs,
  } = useSelector((state) => ({
    userId: state.app.getIn(['currentUser', 'id']),
    linkedOrgs: state.app.getIn(['currentUser', 'linkedOrgs']).toJS() || [],
  }));

  function loadFullStory() {
    if (window.FS) return;

    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
    window['_fs_org'] = FULLSTORY_ORG_ID;
    window['_fs_namespace'] = 'FS';

    (function (m, n, e, t, l, o, g, y) {
      if (e in m) {
        if (m.console && m.console.log) {
          m.console.log('FullStory namespace conflict.');
        }
        return;
      }
      g = m[e] = function (a, b) {
        g.q ? g.q.push([a, b]) : g._api(a, b);
      };
      g.q = [];
      o = n.createElement(t);
      o.async = 1;
      o.crossOrigin = 'anonymous';
      o.src = 'https://' + window['_fs_script'];
      y = n.getElementsByTagName(t)[0];
      y.parentNode.insertBefore(o, y);
      g.identify = function (i, v) {
        g('identify', { uid: i }, v);
      };
      g.setUserVars = function (v) {
        g('setUserVars', v);
      };
      g.event = function (i, v, s) {
        g('event', { n: i, p: v, s: s });
      };
      g.shutdown = function () {
        g('shutdown');
      };
      g.restart = function () {
        g('restart');
      };
      g.log = function (a, b) {
        g('log', [a, b]);
      };
      g.consent = function (a) {
        g('consent', !arguments.length || a);
      };
      g.identifyAccount = function (i, v) {
        g('identifyAccount', { acctId: i }, v);
      };
      g.clearUserCookie = function () {};
    })(window, document, window['_fs_namespace'], 'script', 0, 0, 0);
  }

  const { isPerformanceGroupActive } = useConsentGroups();
  useEffect(() => {
    if (ENABLE_FULLSTORY && isPerformanceGroupActive) {
      if (!window.FS) {
        loadFullStory(FULLSTORY_ORG_ID);
      } else if (typeof window.FS.restart === 'function') {
        window.FS.restart();
      }
    } else {
      if (window.FS && typeof window.FS.shutdown === 'function') {
        window.FS.shutdown();
      }
    }
  }, [isPerformanceGroupActive]);

  if(userId && linkedOrgs?.length > 0) {
    if (ENABLE_FS_USER_PROPERTIES && isPerformanceGroupActive) {
      try {
        FullStory.setUserProperties(userId, { orgIds: linkedOrgs.map(org => org?.organizationId) });
      } catch (error) {
        console.error('[FULLSTORY]', 'Failed to setup Fullstory user', { error });
      }
  }
}

  return null;
};

export default FullStoryManager;
